import { TokenInfo } from '@labb/constellation-core-types';

import { API_ERROR_CODES } from '../../onboarding-api';
import { buildQueryParams, PegaStartingFields } from './buildQueryParams';

type ProductsResponse = {
  canAddAccount: boolean;
};

type ApiGetProductsResult = {
  data?: ProductsResponse;
  errorCode?: API_ERROR_CODES;
};

export async function apiGetProducts(
  baseUrl: string,
  pegaToken: TokenInfo,
  startingFields?: PegaStartingFields
): Promise<ApiGetProductsResult> {
  const queryParams = buildQueryParams(startingFields);
  const url = `${baseUrl}/api/nexus/v1/products?${queryParams}`;

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${pegaToken.access_token}`,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        if (response.status === 401) {
          return {
            errorCode: API_ERROR_CODES.PEGA_TOKEN_EXPIRED,
          };
        }

        return {
          errorCode: API_ERROR_CODES.GENERIC,
        };
      }

      const responseJson = await response.json();

      return { data: responseJson as ProductsResponse };
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
}
